import { useQuery } from "@tanstack/react-query";
import { fetchBill } from "@/api/v1-jwt/bill/bill";
import { useAuth } from "@/providers/auth";

export const useBill = ({
  billId,
  enabled,
  queryFn,
  queryKey,
  ...rest
} = {}) => {
  const { cognitoId } = useAuth();

  const isEnabled = !!cognitoId && enabled !== false && !!billId;
  return useQuery({
    queryKey: ["bills", billId],
    queryFn: () => fetchBill({ cognitoId, billId }),
    enabled: isEnabled,
    ...rest,
  });
};
